var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import calculateFontSizeforFooterButtons from "../../../../helpers/calculateFontSizeforFooterButtons";
import { IconButtonWrap } from "./IconButton.styles";
var IconButton = function (_a) {
    var title = _a.title, dataReason = _a.dataReason, dataType = _a.dataType, className = _a.className, handleClick = _a.handleClick, isStacked = _a.isStacked, activeIcon = _a.activeIcon, _b = _a.isDropdownItem, isDropdownItem = _b === void 0 ? false : _b, restIcon = _a.restIcon, id = _a.id, isOnlyOneButtonPresent = _a.isOnlyOneButtonPresent, rest = __rest(_a, ["title", "dataReason", "dataType", "className", "handleClick", "isStacked", "activeIcon", "isDropdownItem", "restIcon", "id", "isOnlyOneButtonPresent"]);
    return (_jsx(IconButtonWrap, __assign({ isStacked: isStacked, onClick: handleClick, "data-reason": dataReason, "data-type": dataType, "data-analytics": "clicktrackingevent", "data-object": "button", className: className, isDropdownItem: isDropdownItem, isOnlyOneButtonPresent: isOnlyOneButtonPresent, type: "button", id: id, buttonText: title, activeIcon: activeIcon, restIcon: restIcon, fontSize: calculateFontSizeforFooterButtons(isOnlyOneButtonPresent, isDropdownItem) }, rest)));
};
export default IconButton;
//# sourceMappingURL=IconButton.js.map